/* eslint-disable */
import Pusher from "pusher-js"
const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    encrypted: true
});
import { getMemberSession } from "@/utils/auth";

const state = {
    RefreshSenderNumberData: '', //licenseId
    memberSession: (getMemberSession() != null) ? JSON.parse(getMemberSession()) : null,
    RefreshRoomData: false,
    RefreshRoomChatData: false,
    NEW_NUM_UNREAD_MESSAGE_ROOM_Data: {},
    RemoveRoomData: {
        "room_id": '',
        "agent_id": '',
    },
    NEW_UNREAD_MESSAGE_ROOM_Data: [],
    SCAN_QRCODE_Data: {},
    BATTERY_MESSAGE_Data: {},
    BATTERY_MESSAGE_Min: 15, //15% akan tampil
};

const mutations = {
    SET_RefreshRoomChat_Data: (state, value) => {
        state.RefreshRoomChatData = value;
    },
    SET_RefreshSenderNumber_Data: (state, value) => {
        state.RefreshSenderNumberData = value;
    },
    SET_RefreshRoom_Data: (state, value) => {
        state.RefreshRoomData = value;
    },
    SET_RemoveRoom_Data: (state, value) => {
        state.RemoveRoomData = value;
    },
    SET_NEW_NUM_UNREAD_MESSAGE_ROOM_Data: (state, value) => {
        state.NEW_NUM_UNREAD_MESSAGE_ROOM_Data = value;
    },
    SET_NEW_UNREAD_MESSAGE_ROOM_Data: (state, value) => {
        state.NEW_UNREAD_MESSAGE_ROOM_Data = value;
    },
    SET_SCAN_QRCODE_Data: (state, value) => {
        state.SCAN_QRCODE_Data = value;
    },
    SET_BATTERY_MESSAGE_Data: (state, value) => {
        state.BATTERY_MESSAGE_Data = value;
    },
};

const actions = {
    RefreshRoomChat_UNSUB({ commit }, roomId) {
        let sub = "RefRoomChat-"+roomId //license_id + agent id
        pusher.unsubscribe(sub)
    },
    UpdateRefreshRoomChatData({ commit }, value) {
        commit("SET_RefreshRoomChat_Data", value);
    },
    RefreshRoomChat({ commit }, roomId) {
        const channelName = "RefRoomChat-" + roomId
        const existing = pusher.channel(channelName)
        if (existing) {
            existing.unbind('RefreshRoomChat')
        }
        let channel = pusher.subscribe(channelName)
        channel.bind('RefreshRoomChat', (data) => {
            commit("SET_RefreshRoomChat_Data", data);
        })
    },
    UpdateRefreshRoomData({ commit }, value) {
        commit("SET_RefreshRoom_Data", value);
    },
    RefreshRoom_UNSUB({ commit }, dataParams) {
        if (state.memberSession.auto_switching_status == 1) {
            let sub = state.memberSession.id + "_" + dataParams.id //license_id + agent id
            pusher.unsubscribe(sub)
        } else {
            let sub = dataParams.license_id + "_" + dataParams.id //license_id + agent id
            pusher.unsubscribe(sub)
        }
    },
    RefreshSenderNumberByMemberId_UNSUB({ commit }, dataParams) {
        if (state.memberSession.auto_switching_status == 1) {
            let sub = state.memberSession.id + "_" + dataParams.id //member_id + agent id
            pusher.unsubscribe(sub)
        }
    },
    RefreshSenderNumberByMemberId({ commit }, dataParams) {
        console.log("memsess", state.memberSession)
        if (state.memberSession.auto_switching_status == 1) {
            // let hasRoles = state.memberSession.roles.length
            let sub = "autsend_" + state.memberSession.id + "_" + dataParams.id //member_id + agent id
            let channel = pusher.subscribe(sub)
            channel.bind('RefreshSenderNumber', (data) => {
                // console.log("RefreshSenderNumber",data)
                commit("SET_RefreshSenderNumber_Data", data);
            })
        }

    },
    RefreshRoom({ commit }, dataParams) {
        const sub = state.memberSession.auto_switching_status == 1
            ? state.memberSession.id + "_" + dataParams.id
            : dataParams.license_id + "_" + dataParams.id
        const existing = pusher.channel(sub)
        if (existing) {
            existing.unbind('RefreshRoom')
            existing.unbind('NEW_NUM_UNREAD_MESSAGE_ROOM')
        }
        let channel = pusher.subscribe(sub)

        channel.bind('RefreshRoom', (data) => {
            commit("SET_RefreshRoom_Data", data);
        })

        channel.bind('NEW_NUM_UNREAD_MESSAGE_ROOM', (data) => {
            commit("SET_NEW_NUM_UNREAD_MESSAGE_ROOM_Data", data);
        })
    },
    NEW_UNREAD_MESSAGE_ROOM({ commit }, dataParams) {

        if (state.memberSession.auto_switching_status == 1) {
            // console.log("aaa", state.memberSession.id)
            let sub = state.memberSession.id + "_" + dataParams.room_id + "_MESSAGE"
            const existing = pusher.channel(sub)
            if (existing) {
                existing.unbind('NEW_UNREAD_MESSAGE_ROOM')
            }
            let channel = pusher.subscribe(sub)

            channel.bind('NEW_UNREAD_MESSAGE_ROOM', (data) => {
                commit("SET_NEW_UNREAD_MESSAGE_ROOM_Data", data);
            })

            let subAgent = state.memberSession.id + "_" + dataParams.id + "_" + dataParams.room_id + "_MESSAGE" //agent id
            const existingAgent = pusher.channel(subAgent)
            if (existingAgent) {
                existingAgent.unbind('NEW_UNREAD_MESSAGE_ROOM')
            }
            let channelAgent = pusher.subscribe(subAgent)
            channelAgent.bind('NEW_UNREAD_MESSAGE_ROOM', (data) => {
                commit("SET_NEW_UNREAD_MESSAGE_ROOM_Data", data);
            })
        } else {
            let sub = dataParams.license_id + "_" + dataParams.room_id + "_MESSAGE"
            const existing = pusher.channel(sub)
            if (existing) {
                existing.unbind('NEW_UNREAD_MESSAGE_ROOM')
            }
            let channel = pusher.subscribe(sub)

            channel.bind('NEW_UNREAD_MESSAGE_ROOM', (data) => {
                commit("SET_NEW_UNREAD_MESSAGE_ROOM_Data", data);
            })

            let subAgent = dataParams.license_id + "_" + dataParams.id + "_" + dataParams.room_id + "_MESSAGE" //agent id
            const existingAgent = pusher.channel(subAgent)
            if (existingAgent) {
                existingAgent.unbind('NEW_UNREAD_MESSAGE_ROOM')
            }
            let channelAgent = pusher.subscribe(subAgent)
            channelAgent.bind('NEW_UNREAD_MESSAGE_ROOM', (data) => {
                commit("SET_NEW_UNREAD_MESSAGE_ROOM_Data", data);
            })
        }

    },
    NEW_UNREAD_MESSAGE_ROOM_UNSUB({ commit }, dataParams) {
        if (state.memberSession.auto_switching_status == 1) {
            let sub = state.memberSession.id + "_" + dataParams.room_id + "_MESSAGE"
            pusher.unsubscribe(sub)

            let subAgent = state.memberSession.id + "_" + dataParams.id + "_" + dataParams.room_id + "_MESSAGE"
            pusher.unsubscribe(subAgent)
        } else {
            let sub = dataParams.license_id + "_" + dataParams.room_id + "_MESSAGE"
            pusher.unsubscribe(sub)

            let subAgent = dataParams.license_id + "_" + dataParams.id + "_" + dataParams.room_id + "_MESSAGE"
            pusher.unsubscribe(subAgent)
        }
    },
    NEW_NUM_UNREAD_MESSAGE_ROOM({ commit }, dataParams) { //hitung jumlah unread message
        const channelName = state.memberSession.auto_switching_status == 1
            ? state.memberSession.id
            : dataParams.license_id
        const existing = pusher.channel(channelName)
        if (existing) {
            existing.unbind('NEW_NUM_UNREAD_MESSAGE_ROOM')
            existing.unbind('RemoveRoom')
        }
        let channel = pusher.subscribe(channelName)
        channel.bind('NEW_NUM_UNREAD_MESSAGE_ROOM', (data) => {
            commit("SET_NEW_NUM_UNREAD_MESSAGE_ROOM_Data", data);
        })
        //remove room
        channel.bind('RemoveRoom', (data) => {
            commit("SET_RemoveRoom_Data", data);
        })
    },
    NEW_NUM_UNREAD_MESSAGE_ROOM_UNSUB({ commit }, dataParams) {
        const channelName = state.memberSession.auto_switching_status == 1
            ? state.memberSession.id
            : dataParams.license_id
        const channel = pusher.channel(channelName)
        if (channel) {
            channel.unbind('NEW_NUM_UNREAD_MESSAGE_ROOM')
            channel.unbind('RemoveRoom')
        }
    },
    SCAN_QRCODE({ commit }, dataParams) {
        let channel = pusher.subscribe(dataParams.license_id)
        channel.bind('SCAN_QRCODE', (data) => {
            commit("SET_SCAN_QRCODE_Data", data);
        })
    },
    SCAN_QRCODE_Unsub({ commit }, dataParams) {
        if (dataParams && dataParams.license_id) {
            pusher.unsubscribe(dataParams.license_id)
        }
        commit("SET_SCAN_QRCODE_Data", {});
    },
    SCAN_QRCODE_DESTROY({ commit }, dataParams) {
        var data = {}
        commit("SET_SCAN_QRCODE_Data", data);
    },
    BATTERY_MESSAGE({ commit }, dataParams) {
        let channel = pusher.subscribe(dataParams.license_id)
        channel.bind('BATTERY_MESSAGE', (data) => {
            // console.log("dataa puser", data)
            commit("SET_BATTERY_MESSAGE_Data", data);
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/pusher.js